'use client';

import clsx from 'clsx';
import { useState } from 'react';
import { Form } from './Form';
import { useSignUpFormSuccess } from './SignUpFormSuccessContext';

export const SignUpForm = ({ isTravelNewsLetter }: { isTravelNewsLetter?: boolean }) => {
  const [success, setSuccess] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const notifySignUpFormSuccess = useSignUpFormSuccess();

  if (success) {
    return (
      <p
        className={clsx(
          'text-green-dark',
          { 'font-medium': isTravelNewsLetter },
          { 'py-2': isTravelNewsLetter },
        )}
      >
        Check your inbox for details!
      </p>
    );
  }

  if (fetchError) {
    return (
      <div className={clsx('flex', 'flex-col', 'gap-2')}>
        <p className={clsx('text-red-dark', 'my-0', { 'font-medium': isTravelNewsLetter })}>
          Something went wrong. Please try again.
        </p>
        <button
          type="button"
          aria-label="Try again"
          className={clsx(
            'bg-green-default',
            'text-white',
            'text-small',
            'font-medium',
            'rounded',
            'px-6',
            'box-border',
            'hover:bg-green-dark',
            'hover:cursor-pointer',
            'w-[152px]',
            'h-[44px]',
            'text-center',
          )}
          onClick={() => setFetchError(false)}
        >
          TRY AGAIN
        </button>
      </div>
    );
  }

  return (
    <Form
      onError={() => setFetchError(true)}
      onSuccess={() => {
        setSuccess(true);
        notifySignUpFormSuccess?.();
      }}
      isTravelNewsLetter={isTravelNewsLetter}
    />
  );
};
